import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddUserSlice = createSlice({
    name: "addUser",
    initialState,
    reducers: {
        addUserRequest(state) {
            state.loading = true;
        },
        addUserRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addUserRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    addUserRequest,
    addUserRequestSuccess,
    addUserRequestError,
} = AddUserSlice.actions;

export default AddUserSlice.reducer;